import React from 'react';
import Immutable from 'immutable';

import component, {classnames, makePath} from './component';
import Link from './Link';
import Api from '../api';


export default component('Nav', function({route, data, user, bottom}) {
  const currentUrl = makePath(route.get('name'), route.get('params').toJS());

  const cls = {
    'Nav-ItemBorder':       !bottom,
    'Nav-ItemBorderBottom':  bottom
  };

  const clsItem = {
    'Nav-item': true,
    'Nav-item--top':   !bottom,
    'Nav-item--bottom': bottom
  };

  function renderItem(item, idx) {
    if (!bottom && item.get('bottomOnly')) {
      return null;
    }

    const name = item.get('name');
    const href = item.get('href');
    const url = href ? href : makePath(name, (item.get('params') || Immutable.Map()).toJS());
    return (
      <div key={url} className={classnames(clsItem, {'Nav-item--current': url === currentUrl})}>
        <Link key={idx} href={url}>
          {item.get('title')}
          <div className={classnames(cls)}></div>
        </Link>
      </div>
    )
  }

  return (
    <div className='Nav'>
      {data.map(renderItem)}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/Nav.js